import axios from "axios";
import { API_PRE_URL, TOKEN_KEY, BUYER_INFO_KEY } from '@/constants';
import { message } from 'antd'
import jsCookie from 'js-cookie'
import i18n from '@/i18n'
import langsInterceptors from './langsInterceptors'
import { openAuthModal } from '@/components/AuthModal/authModalController';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = "production" === 'development' ? '/api/jdx/mini' : `${API_PRE_URL}/jdx/mini`;
axios.defaults.timeout = 10000;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

axios.interceptors.request.use(config => {
  const token = jsCookie.get(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers.lang = i18n.language || 'zh_CN';
  config.headers['accept-language'] = i18n.language.replace(/_/g, '-') || 'zh-CN';
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  if(response.config.url?.includes('i18n/web/latest')) {
    return response.data;
  }
  if(response.data.code === 401) {
    jsCookie.remove(TOKEN_KEY);
    localStorage.removeItem(BUYER_INFO_KEY);
    openAuthModal({ reason: 'unauthorized' });
    return Promise.reject(response.data);
  }
  if(response.data.code !== 0) {
    return Promise.reject(response.data);
  }
  return response.data;
}, error => {
  const status = error.response?.status ?? error.status;
 
  switch (status) {
    case 401: {
      jsCookie.remove(TOKEN_KEY);
      localStorage.removeItem(BUYER_INFO_KEY);
      openAuthModal({ reason: 'unauthorized' });
      return Promise.reject(error.response?.data ?? error);
    }
    case 500: {
      if (error.response?.data?.msg) {
        message.error(error.response.data.msg);
        return Promise.reject(error.response.data);
      }
    }
  }
  return Promise.reject(error);
});

axios.interceptors.response.use(langsInterceptors)

export default axios;
